import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useIntl, defineMessages, FormattedMessage } from 'react-intl';
import { Formik, Form, Field, useFormikContext } from 'formik';

import { Button } from 'primereact/button';
import * as Yup from 'yup';
import { useHistory } from 'react-router-dom';
import { DropdownWithValidation, InputTextComponent, TextAreaComponent } from '../../components/prime-formik';
import { AccountContext } from '../../components/AccountContext';

const messages = defineMessages({
  TEXT: {
    id: 'item-bank-management.context-type.text',
    defaultMessage: 'Text',
  },
  IMAGE: {
    id: 'item-bank-management.context-type.image',
    defaultMessage: 'Image',
  },
  supportMaterialType: {
    id: 'menu.item-bank-management.support-material-type',
    defaultMessage: 'Support Material Type',
  },
  supportMaterialCode: {
    id: 'menu.item-bank-management.support-material-code',
    defaultMessage: 'Support Material Code',
  },
  supportMaterialContent: {
    id: 'menu.item-bank-management.support-material-content',
    defaultMessage: 'Support Material Content',
  },
});

const AddContext = ({ availableContextTypes }) => {
  const currentAccount = useContext(AccountContext);
  const history = useHistory();
  const { formatMessage } = useIntl();
  const { setFieldValue } = useFormikContext();

  const contextTypeOptions = availableContextTypes
    .filter((contextType) => contextType !== 'IMAGE')
    .map((contextType) => ({
      value: contextType,
      label: formatMessage(messages[contextType]),
    }));

  const initialValues = {
    type: '',
    code: '',
    content: '',
  };

  const validationSchema = Yup.object().shape({});

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, formikBag) => {
        formikBag.resetForm();

        setFieldValue('context', { ...values });

        history.push(`/accounts/${currentAccount}/add-itembank-assessment-content/add-cognitive-items`);
      }}
      render={({ handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <div className="cognitive-context-controls">
            <div className="input-label">{formatMessage(messages.supportMaterialType)}</div>
            <div>
              <Field id="type" name="type" component={DropdownWithValidation} options={contextTypeOptions} />
            </div>
          </div>
          <div className="cognitive-context-controls">
            <div className="input-label">{formatMessage(messages.supportMaterialCode)}</div>
            <div>
              <Field id="code" name="code" component={InputTextComponent} />
            </div>
          </div>
          <div className="cognitive-context-controls">
            <div className="input-label">{formatMessage(messages.supportMaterialContent)}</div>
            <div>
              <Field id="content" name="content" component={TextAreaComponent} />
            </div>
          </div>

          <div>
            <FormattedMessage id="actions.next" defaultMessage="Next">
              {(text) => <Button type="submit" label={text} />}
            </FormattedMessage>
            <FormattedMessage id="actions.back" defaultMessage="Back">
              {(text) => (
                <Button type="button" onClick={() => history.goBack()} className="p-button-secondary" label={text} />
              )}
            </FormattedMessage>
          </div>
        </Form>
      )}
    />
  );
};

AddContext.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  availableContextTypes: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default AddContext;
